module.exports = __webpack_public_path__ + "static/chp-ad-3-b0d477881c17a14eb382951f2b1c650d.jpg";